import "./styles.css";

import * as Sentry from "@sentry/react";
import { useEffect, useState } from "react";
import React from "react";
// constants
import { useTranslation } from "react-i18next";

import { PaymentBrand } from "../../../../setup/api/services/payment/models";
import { getUserAllAddress } from "../../../../setup/api/services/user";
import { IUserAddressResponse } from "../../../../setup/api/services/user/models";
import { HYPER_PAY_CALL_BACK_URL } from "../../../../setup/constants";
import { AuthConfig } from "../../../../setup/context/config/authConfig";
import { CARD_DETAILS } from "../../constants";
// styles
import styles from "./styles.module.scss";

declare global {
  interface Window {
    wpwl: unknown;
  }
}

interface Props {
  checkoutId: string;
  contractId: string;
  dataForAmpli: any;
  paymentBrand?: PaymentBrand;
}

const PaymentMethods = ({
  checkoutId,
  contractId,
  dataForAmpli,
  paymentBrand,
}: Props): JSX.Element | null => {
  const [address, setUserAddress] = useState<
    IUserAddressResponse["data"] | undefined
  >(undefined);
  const userId = AuthConfig.getUserInfo().id;
  const { t } = useTranslation();
  useEffect(() => {
    if (userId) {
      getAddress(userId);
    }
  }, [userId]);

  const getAddress = async (id: string) => {
    try {
      const result = await getUserAllAddress(Number.parseInt(id));
      setUserAddress(result?.data[0]);
    } catch (error) {
      Sentry.captureException(error);
      setUserAddress({
        id: null,
        addressLabel: "",
        buildingNo: "",
        countryCode: "",
        city: "",
        district: "",
        street: "",
        verified: false,
      });
      console.error("error", error);
    }
  };

  useEffect(() => {
    if (checkoutId !== "" && address) {
      const onReady = () => {
        setTimeout(() => {
          const button: HTMLButtonElement | null =
            document.querySelector(".wpwl-button-pay");
          button?.addEventListener("click", (event) => {
            const holder: HTMLInputElement | null = document.querySelector(
              ".wpwl-control-cardHolder"
            );
            const holderValue = holder?.value as string;
            if (holderValue?.trim()?.length < 2) {
              try {
                event.preventDefault();
                holder?.classList.add("wpwl-has-error");
                const element = document.createElement("div");
                element?.classList.add("wpwl-hint-cardHolderError");
                element?.setAttribute("dir", "rtl");
                element.innerHTML = CARD_DETAILS.CARD_HOLDER_IMP;
                holder?.after(element);
              } catch (error) {
                console.info("error", error);
              }
            } else {
              const error: HTMLElement | null = document?.querySelector(
                ".wpwl-hint-cardHolderError"
              );
              if (error) error.remove();
              holder?.classList.remove("wpwl-has-error");
              return true;
            }
          });
        }, 6000);
      };
      const onBeforeSubmitCard = () => {
        setTimeout(() => {
          const button: HTMLButtonElement | null =
            document.querySelector(".wpwl-button-pay");
          button?.addEventListener("click", (event) => {
            const holder: HTMLInputElement | null = document.querySelector(
              ".wpwl-control-cardHolder"
            );
            const address: any = document.querySelector(".wpwl-form-card");
            address && address.classList.add("hideIt");
            const holderValue = holder?.value as string;
            if (holderValue?.trim()?.length < 2) {
              try {
                event.preventDefault();
                holder?.classList.add("wpwl-has-error");
                const element = document.createElement("div");
                element?.classList.add("wpwl-hint-cardHolderError");
                element?.setAttribute("dir", "rtl");
                holder?.after(element);
              } catch (error) {
                console.info("error", error);
              }
            } else {
              const error: HTMLElement | null = document?.querySelector(
                ".wpwl-hint-cardHolderError"
              );
              if (error) error.remove();
              holder?.classList.remove("wpwl-has-error");
              return true;
            }
          });
        }, 6000);
      };
      try {
        const outterScript = document.createElement("script");
        let wpwlOptions: unknown = undefined;

        if (paymentBrand === PaymentBrand.APPLEPAY) {
          wpwlOptions = {
            applePay: {
              displayName: "Waffy App",
              total: { label: "Gotrah, Ventures." },
            },
          };
        } else {
          wpwlOptions = {
            locale: "ar",
            onReady: onReady(),
            onBeforeSubmitCard: onBeforeSubmitCard(),
            billingAddress: {
              country: address?.countryCode,
              state: address?.addressLabel,
              city: address?.city,
              postcode: address?.postalCode,
              street1: address?.street,
            },
            mandatoryBillingFields: {
              country: true,
              state: true,
              city: true,
              postcode: true,
              street1: true,
              street2: false,
            },
          };
        }
        outterScript.innerHTML = `var wpwlOptions = ${JSON.stringify(
          wpwlOptions
        )}`;
        document.body.appendChild(outterScript);
      } catch (error) {
        Sentry.captureException(error);
        console.error(error);
      }

      scriptInjection(checkoutId);
    }
  }, [checkoutId, address, paymentBrand]);

  const scriptInjection = async (checkoutId: string) => {
    return new Promise(function (resolve, reject) {
      const paymentFormUrl = process.env.REACT_APP_HYPER_PAY_PAYMENT_FORM || "";
      const script = document.createElement("script");
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      script.src = `${paymentFormUrl}?checkoutId=${checkoutId}`;
      document.body.appendChild(script);
    });
  };

  if (!checkoutId) return null;

  return (
    <>
      {paymentBrand === PaymentBrand.APPLEPAY ? (
        <h4>{t("lbl_click_on_apple_pay_button_to_continue")}</h4>
      ) : (
        <h4>{t("lbl_card_details_title")}</h4>
      )}
      {paymentBrand !== PaymentBrand.APPLEPAY && (
        <p className={"p1"}>{t("lbl_add_payment_card_data_sub_title")}</p>
      )}
      <div
        className={`${styles["payment_widget"]} ${
          paymentBrand === PaymentBrand.APPLEPAY && styles.center_align
        }`}>
        <form
          action={`${HYPER_PAY_CALL_BACK_URL}?contractId=${contractId}&paymentBrand=${paymentBrand}`}
          className={`${styles.payment_widget} paymentWidgets ${
            paymentBrand === PaymentBrand.APPLEPAY && styles.center_align
          }`}
          data-brands={paymentBrand}></form>
      </div>
    </>
  );
};

export default PaymentMethods;
